import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../../contexts/LanguageContext";
import { translations } from "../../../../translations";
import logo from "../../../../assets/logo.png";

const LandingPageHeader = () => {
  const navigate = useNavigate();
  const { language, setLanguage } = useContext(LanguageContext);
  const t = translations[language];
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const dropdownItems = {
    why: [
      { title: t.nav.menu.aiLearning, id: "ai-powered-learning" },
      { title: t.nav.menu.interactiveModules, id: "interactive-modules" },
      { title: t.nav.menu.feedbackScaffolding, id: "feedback-scaffolding" },
      { title: t.nav.menu.advancedManagement, id: "advanced-management" },
    ],
    products: [{ title: "SocratesLab", id: "login" }],
    language: ["EN", "FR"],
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      const headerOffset = 80;
      const elementPosition = contactSection.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdown) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdown);
    }
  };

  return (
    <nav className="landing-nav">
      <div className="nav-logo">
        <img src={logo} alt="SocratesLab Logo" className="nav-logo-image" />
        <span>SocratesLab</span>
      </div>

      <button className="mobile-menu-toggle" onClick={toggleMenu}>
        {isMenuOpen ? "✕" : "☰"}
      </button>

      <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        <div className={`dropdown ${activeDropdown === "why" ? "active" : ""}`}>
          <span onClick={() => toggleDropdown("why")}>{t.nav.why}</span>
          <div className="dropdown-content">
            {dropdownItems.why.map((item, index) => (
              <a
                key={index}
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleScrollTo(item.id);
                  setIsMenuOpen(false);
                }}
              >
                {item.title}
              </a>
            ))}
          </div>
        </div>

        <div
          className={`dropdown ${
            activeDropdown === "products" ? "active" : ""
          }`}
        >
          <span onClick={() => toggleDropdown("products")}>
            {t.nav.products}
          </span>
          <div className="dropdown-content">
            {dropdownItems.products.map((item, index) => (
              <a
                key={index}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/login");
                  setIsMenuOpen(false);
                }}
              >
                {item.title}
              </a>
            ))}
          </div>
        </div>

        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            scrollToContact();
            setIsMenuOpen(false);
          }}
        >
          {t.nav.company}
        </a>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            scrollToContact();
            setIsMenuOpen(false);
          }}
        >
          {t.nav.about}
        </a>

        <button className="demo-button" onClick={scrollToContact}>
          {t.nav.demo}
        </button>

        <div
          className={`dropdown language-dropdown ${
            activeDropdown === "language" ? "active" : ""
          }`}
        >
          <span onClick={() => toggleDropdown("language")}>{language}</span>
          <div className="dropdown-content">
            {dropdownItems.language.map((lang, index) => (
              <a
                key={index}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setLanguage(lang);
                  setIsMenuOpen(false);
                }}
              >
                {lang}
              </a>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default LandingPageHeader;
